import React, { useEffect, useState } from "react";
import NavBar from "../../../Components/Navbar/navbar";
import styles from "../../Styles/tables.module.css";
import axios from "axios";
import { TbArrowBigLeftLineFilled, TbArrowBigRightLineFilled } from "react-icons/tb";
import { useParams } from "react-router-dom";
import RefreshToken from "../../../Components/RefreshToken/RefreshToken";
import { Url, getUser } from "../../../Constants/globals";
import GoBack from "../../../Components/GoBack/goback";

async function getUsersLogs(id, page){
  try {
    const res = await axios
    .get(`${Url}/users/${id}/logs?page=${page ? page : 1}`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getUsersLogs(id, page);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

function LogsUtilizadores({userPermissions}) {

  const { id } = useParams();
  const [loadingData, setLoadingData] = useState(true);
  const [logsData, setLogsData] = useState([]);
  const [currentPage, setCurrentPage] = useState("");
  const [nextPage, setNextPage] = useState("");
  const [previousPage, setPreviousPage] = useState("");

  async function assignData() {
    const thisUsersData = await getUsersLogs(id, currentPage);
    setLogsData(thisUsersData);
    setCurrentPage(thisUsersData.current_page);
    setNextPage(thisUsersData.next_page);
    setPreviousPage(thisUsersData.prev_page);
    setLoadingData(false);
  }

  async function handlePageChange(next) {
    if (next && nextPage) {
      const newUsersData = await getUsersLogs(id, nextPage);
      setLogsData(newUsersData);
      setCurrentPage(newUsersData.current_page);
      setNextPage(newUsersData.next_page);
      setPreviousPage(newUsersData.prev_page);
    }
    else if (!next && previousPage) {
      const newUsersData = await getUsersLogs(id, previousPage);
      setLogsData(newUsersData);
      setCurrentPage(newUsersData.current_page);
      setNextPage(newUsersData.next_page);
      setPreviousPage(newUsersData.prev_page);
    }
    else {
      return;
    }
  }

  useEffect(() => {
    assignData();
  }, []);

  return (
    <div className="body">
      <NavBar current={"utilizadores"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData
        ? ""
        :
        <div>
          <div className={styles.content}>
            <GoBack backRoute={`/utilizadores`} />
            <div className={styles.table}>
              <div className={styles.usersLogsColumn}>
                <p>Data</p>
                <p>Ação</p>
              </div>
              <div className={styles.scrollContent}>
                {
                  logsData?.logs?.length > 0 ?
                  logsData?.logs?.map((log, index) =>
                    <div key={log.id} className={styles.usersLogsInfo} style={ index % 2 !== 0 ? {backgroundColor: "var(--inputBackground)"} : {}}>
                      <p title={log.date} style={{textAlign: "center"}}>{log.date ? log.date : "-"}</p>
                      <div>
                        <p>{log.log ? log.log : "-"}</p>
                        <p>
                          { log.reason ? <label style={{fontWeight: "bold"}}>Motivo: </label> : "" }
                          { log.reason ? log.reason : "" }
                        </p>
                        <p>
                          { log.added_permissions ? <label style={{fontWeight: "bold"}}>Permissões adicionadas: </label> : "" }
                          { log.added_permissions ? log.added_permissions : "" }
                        </p>
                        <p>
                          { log.removed_permissions ? <label style={{fontWeight: "bold"}}>Permissões removidas: </label> : "" }
                          { log.removed_permissions ? log.removed_permissions : "" }
                        </p>
                      </div>
                    </div>
                  )
                  :
                  <div className={styles.noData} style={{marginTop: "20px"}}>
                    Não existem logs
                  </div>
                }
              </div>
              {
                previousPage || nextPage ?
                <div className={styles.arrows}>
                  <TbArrowBigLeftLineFilled size={28} color={previousPage ? "" : "#00000000"} onClick={() => handlePageChange(false)}/>
                  {currentPage ? currentPage : ""}
                  <TbArrowBigRightLineFilled size={28} color={nextPage ? "" : "#00000000"} onClick={() => handlePageChange(true)}/>
                </div>
                : ""
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default LogsUtilizadores;